import * as HLF from "html-living-framework";
import { Application } from "./Application";
import { Culture } from "./Data/Culture";
import * as Topics from "./Data/Topics";
import * as VO from "./Data/VoiceOver";

import { SOLO_ENDED } from "./Data/Topics";
import { Character, CharacterName } from "./GameObjects/Character";
import CharacterManager from "./GameObjects/CharacterManager";
import { InteruptType, VoiceCategory } from "./GameObjects/VoiceOverManager";
import { Game } from "./States/Game";
import AudioPreloadManager, { PRIORITY } from "./Utils/AudioPreloadManager";

export default class Gameplay {
    public static STARTING_CULTURE: Exclude<Culture, Culture.NumElements>;
    private static _Instance: Gameplay;
    // private _introFinished: boolean = false;
    public static get Instance(): Gameplay {
        if (Gameplay._Instance === undefined) {
            Gameplay._Instance = new Gameplay();
        }
        return Gameplay._Instance;
    }

    public characterManager?: CharacterManager;

    public get currentCharacter() { return this._currentCharacter; }
    public get currentCulture() { return this._currentCulture; }

    private _currentCharacter: CharacterName = CharacterName.Carmen;
    private _currentCulture: Culture = Gameplay.STARTING_CULTURE;

    public constructor() {
        PubSub.subscribe(Topics.CULTURE_CHANGE_BEGIN, this.onCultureChangeBegin.bind(this));
        PubSub.subscribe(Topics.CULTURE_CHANGE_COMPLETE, this.onCultureChangeComplete.bind(this));
        PubSub.subscribe(Topics.INTRO_COMPLETED, this.onIntroComplete.bind(this));
    }

    protected onIntroComplete() {
        PubSub.publishSync(Topics.ENABLE_INPUT_CHARACTERS, undefined);
/*
        const voiceOver1 = VO.CULTURE[this.currentCulture];
        const voiceOver2 = VO.INSTRUMENT[this.currentCulture][this.currentCharacter];
        HLF.ArrayUtils.shuffle(VO.FACT[this.currentCulture][this.currentCharacter]);
        const voiceOver3 = VO.FACT[this.currentCulture][this.currentCharacter][0];
        Application.instance.voiceOver.play(voiceOverKey);
        const once = PubSub.subscribe(Topics.SOLO_ENDED, () => {
            PubSub.unsubscribe(once);
        });
*/

        // preload audio for the current culture
        AudioPreloadManager.UpdatePriority({
            character: this._currentCharacter,
            culture: this._currentCulture,
            alternate: this.characterManager!.characters[this._currentCharacter].alternate,
            priority: PRIORITY.IMMEDIATELY,
        });

        // preload audio for the next culture
        const nextCulture = (this.currentCulture + 1) % Culture.NumElements;
        AudioPreloadManager.UpdatePriority({
            culture: nextCulture,
            priority: PRIORITY.SOON,
        });

        AudioPreloadManager.paused = false;
    }
    protected onCultureChangeBegin(pTopic: string, pData: Culture): void {

        const nextCulture = (pData + 1) % Culture.NumElements;
        const previousCulture = (pData - 1 + Culture.NumElements) % Culture.NumElements;
        this._currentCharacter = (this._currentCharacter + HLF.Random.intBetween(1, 3)) % CharacterName.NumElements;
        this._currentCulture = pData;

        AudioPreloadManager.paused = true;

        for (let i = 0; i < CharacterName.NumElements; i++) {
            AudioPreloadManager.UpdatePriority({
                culture: pData,
                character: i,
                alternate: this.characterManager!.characters[i].alternate,
                priority: PRIORITY.NEXT,
            });
            AudioPreloadManager.UpdatePriority({
                culture: pData,
                character: i,
                alternate: !this.characterManager!.characters[i].alternate,
                priority: PRIORITY.SOON,
            });
        }

        AudioPreloadManager.UpdatePriority({
            culture: nextCulture,
            priority: PRIORITY.LATER,
        });

        AudioPreloadManager.UpdatePriority({
            culture: previousCulture,
            priority: PRIORITY.EVENTUALLY,
        });

        AudioPreloadManager.UpdatePriority({
            culture: pData,
            character: this._currentCharacter,
            alternate: this.characterManager!.characters[this._currentCharacter].alternate,
            priority: PRIORITY.IMMEDIATELY,
        });

        AudioPreloadManager.paused = false;

        if (pData !== Culture.NumElements && this._currentCharacter !== CharacterName.NumElements) {
            const voiceOver1 = VO.CULTURE[pData];
            const voiceOver2 = VO.INSTRUMENT[pData][this._currentCharacter];
            HLF.ArrayUtils.shuffle(VO.FACT[pData][this._currentCharacter]);
            const voiceOver3 = VO.FACT[pData][this._currentCharacter][0];
            Application.instance.audio.load([voiceOver1, voiceOver2, voiceOver3], HLF.AudioCategory.VO);
        }

        PubSub.publishSync(Topics.DISABLE_INPUT, undefined);
    }

    protected onCultureChangeComplete(pTopic: string, pData: Culture): void {
        if (pData !== Culture.NumElements && this._currentCharacter !== CharacterName.NumElements) {
            const afterAllVoiceoversComplete = () => {
                this.characterManager!.characters[this._currentCharacter].simulateClick(true);
                const once = PubSub.subscribe(Topics.SOLO_STARTED, () => {
                    PubSub.publishSync(Topics.ENABLE_INPUT, undefined);
                    PubSub.unsubscribe(once);
                });
            };

            // if no audio and no captions, skip playing the voiceovers
            if (Application.instance.audio.getCategoryVolume(HLF.AudioCategory.VO) <= 0) {
                if (!Application.instance.captions.active) {
                    afterAllVoiceoversComplete();
                    return;
                }
            }

            const voiceOver1 = VO.CULTURE[pData];
            const voiceOver2 = VO.INSTRUMENT[pData][this._currentCharacter];
            const voiceOver3 = VO.FACT[pData][this._currentCharacter][0];

            // TODO: make VoiceOverManager.play() take an array of strings
            Application.instance.voiceOver.play(voiceOver1, InteruptType.EQUAL, VoiceCategory.FUN_FACT, () => {
                Application.instance.voiceOver.play(voiceOver2, InteruptType.EQUAL, VoiceCategory.FUN_FACT, () => {
                    Application.instance.voiceOver.play(voiceOver3, InteruptType.EQUAL, VoiceCategory.FUN_FACT, () => {
                        afterAllVoiceoversComplete();
                    });
                });
            });
        }
    }
}
